import styled from '@emotion/styled';
import { COLORS3, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const Container = styled.div`
  // Temp styles for positioning
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${COLORS3.BLACK_005};
  border-radius: 100px;

  height: 56px;
  padding: ${SPACING.SM} ${SPACING.S16};
  margin-bottom: ${SPACING.S32};
  ${MEDIA_QUERY.DESKTOP} {
    margin-bottom: ${SPACING.LG};
    height: 44px;
    padding: ${SPACING.SM};
  }
`;

export const SearchInput = styled.input`
  border: none;
  margin-left: ${SPACING.S16};
  background-color: transparent;
  width: 100%;
`;
